import { defa }      from 'defa-object';
import Accessories   from 'scripts/defa/control/accessories-holder/accessories/collection-accessories';
import ControlModel  from 'scripts/poppet/control-model';

/**
 * defa.models.AccessoriesHolder
 * The DEFA AccessoriesHolder model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	linkcom: apiHost + '/linkcom/',
	homeAutomation: '/homeAutomation/diyWirelessDevices',
};

const AccessoriesHolder = ControlModel.extend( {
	
	url: function() {
		return api.linkcom + this.get('id') + api.homeAutomation + this.getAttributes();
	},
	
	saveUrl: function (){
		return api.linkcom + this.get('id') + api.homeAutomation;
	},
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend({},ControlModel.prototype.defaults,
		{
			allAccessories: [],
			allAccessoriesError: null
		}),
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	addAccessory( serial, options ) {
		let self = this;
		let url = this.saveUrl();
		$.ajax({
			 type: 'POST',
			 url: url,
			 contentType: 'application/json',
			 data:  JSON.stringify( {
				 command: 'remotePairUnit',
				 payload:{
					 sensorId : serial,
				 }
			 })
		 })
		 .done( function () {
			 console.log( 'remotePairUnit success!' );
			 self.refresh();
		 } )
		 .fail( function ( response ) {
			 console.error( 'remotePairUnit error' );
			 options.error(response.responseJSON.message)
		 } );
	},
	
	addAllAccessory( accessory ) {
		this.get('allAccessories').add(accessory, {at: 0});
	},

	setAllAccessory( accessory ) {
		this.get('allAccessories').reset(accessory);
	},
	
	fetchAllAccessories: function(options) {
		this.fetch({
			success: options.success,
		});
	},
	
	removeAccessory: function ( accessory, options ) {
		let self = this;
		let url = this.saveUrl();
		
		$.ajax( {
			 type       : 'POST',
			 url        : url,
			 contentType: 'application/json',
			 data       : JSON.stringify( {
				 command: 'remoteUnpairUnit',
				 payload: {
					 sensorId: accessory.get( 'id' ),
				 }
			 } )
		 })
		 .done( function ( response ) {
			 if ( options && options.success ) {
				 options.success( response.responseJSON.message )
			 }
			 self.refresh();
			 let digiHeatModel = channel.request( 'digiHeatModes' ).get( self.get('id'));
			 let glenDimplexType = 5;
			 let deviceType = accessory.get('deviceType');
			 if(deviceType === glenDimplexType){
				 digiHeatModel.fetch();
			 }
		 } )
		 .fail( function ( response ) {
			 if ( options && options.error ) {
				 options.error( response.responseJSON.message )
			 }
		 } );
	},
	
	saveZone: function ( accessory, options ) {
		console.log('saveZone - trying ajax');
		let url = this.saveUrl();

		$.ajax( {
			 type       : 'POST',
			 url        : url,
			 contentType: 'application/json',
			 data       : JSON.stringify( {
				 command: 'writeWirelessSetting',
				 payload: {
					 sensorId: accessory.get( 'id' ),
					 zone    : accessory.get( 'zone' ),
				 }
			 } )
		 })
		 .done( function ( response ) {
			 if ( options && options.success ) {
				 options.success( response.responseJSON.message )
			 }
		 } )
		 .fail( function ( response ) {
			 if ( options && options.error ) {
				 options.error( response.responseJSON.message )
			 }
		 } );
	},
	
	saveDimplex: function ( accessory, options ) {
		let self = this;
		let url = this.saveUrl();
		$.ajax( {
			 type       : 'POST',
			 url        : url,
			 contentType: 'application/json',
			 data       : JSON.stringify( {
				 command: 'writeWirelessSetting',
				 payload: {
					 sensorId   : accessory.get( 'id' ),
					 dimplexType: accessory.get( 'dimplexType' ),
				 }
			 } )
		 })
		 .done( function ( response ) {
			 if ( options && options.success ) {
				 options.success( response.responseJSON.message )
			 }
			 console.log( 'saveDimplex: writeWirelessSetting success!' );
			 let dependentModel = channel.request( 'digiHeatModes' ).get( self.get('id'));
			 dependentModel.fetch();
		 } )
		 .fail( function ( response ) {
			 if ( options && options.error ) {
				 options.error( response.responseJSON.message )
			 }
			 console.error( 'saveDimplex: writeWirelessSetting failed' );
		 } );
	},
	
	parse: function( response, options ) {
		//Do a check to decide if response is valid for parsing
		if(response) {
			let newModelAttributes = {};
			
			if(response.pairedList){
				this.parseAttribute('allAccessories', response.pairedList, options, newModelAttributes);
				if('success' === response.pairedList.status && newModelAttributes.allAccessories){
					newModelAttributes.allAccessories = new Accessories(response.pairedList.value)
				}
			}
			newModelAttributes.modelError = null;
			this.receivedData( newModelAttributes );
			channel.request( 'accessoriesHolders' ).add( newModelAttributes, { merge: true } );
		}
	},
	
	getAttributes: function() {
		return '?attrs=pairedList';
	},
	
	/**
	 * Filters the accessories.
	 * @return {Array[]} A list containing only the accessories that is connected to a given zone.
	 */
	getZoneAccessories: function(zoneNumber){
		return this.get( 'allAccessories' ).filter( function ( accessory ) {
			if ( null === accessory.get('zone')) {
				return 0 === zoneNumber;
			}
			return accessory.get( 'zone' ) === zoneNumber;
		} );
	},
} );

export default AccessoriesHolder;
